import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs';
import { LangService } from 'src/app/services/lang.service';
import { selectUserDetails } from 'src/app/store/auth/auth.selector';
import { AutoUnsubscribeComponent } from 'src/app/utility/auto-unsubscribe.component';
import { UserProfile } from 'src/app/utility/model/user-profile';
import { environment } from 'src/environments/environment';
import {
  getFullName,
  getMyNameAcronym,
  getNameAcronym,
  getProfPic,
  toggleStyleDisplay,
} from '../../utility/common-logic';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  userDetails: UserProfile;
  imgUrl = environment.url.img;
  style: Partial<CSSStyleDeclaration> = { display: 'none' };
  isBSTLApp = environment.settings.app === 'bstl';
  isPanelOpen: boolean = false;

  constructor(
    private store: Store,
    public lang: LangService,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .pipe(select(selectUserDetails), takeUntil(this.destroy$))
      .subscribe((user) => {
        this.userDetails = user;
      });
  }

  toggleStyleDisplay(style: Partial<CSSStyleDeclaration>) {
    this.isPanelOpen = !this.isPanelOpen;
    return toggleStyleDisplay(style);
  }

  get profPic() {
    return getProfPic(this.userDetails);
  }

  get acronym() {
    if (this.isBSTLApp) {
      return getNameAcronym(this.userDetails?.department_name);
    } else {
      return getMyNameAcronym(this.userDetails);
    }
  }

  get fullName() {
    return getFullName(this.userDetails);
  }

  clickOnProfile(style) {
    // this.isPanelOpen = !this.isPanelOpen;
    const container = document.querySelector('.page-content');
    if (style.display == 'block') {
      this.isPanelOpen = true;
      this.renderer.addClass(container, 'mat-content-layer');
    } else {
      this.isPanelOpen = false;
      this.renderer.removeClass(container, 'mat-content-layer');
    }
  }

  toggleHandler(value: boolean) {
    this.style.display = value ? 'block' : 'none';
    this.clickOnProfile(this.style);
  }
}
